import React, { useEffect, useRef, useState } from "react";
import logoVideo from "../media/TatieSoso_Logo_Animated.mp4";
import logoSound from "../media/logo_sound.mp3";
import { useLang } from "../i18n/LanguageContext";

// Même couleur que le fond de la vidéo du logo (charte : #D4CDC1)
const BG = "#D4CCC1";

const SplashScreen = ({ onDone }) => {
  const videoRef = useRef(null);
  const audioRef = useRef(null);
  const [fading, setFading] = useState(false);
  const { t } = useLang();

  const doneRef = useRef(false);

  const finish = () => {
    if (doneRef.current) return; // éviter un double appel (fin de vidéo + minuterie)
    doneRef.current = true;
    if (audioRef.current) audioRef.current.pause();
    setFading(true);
    setTimeout(() => onDone(), 800);
  };

  // Sécurité : si la vidéo ne se termine jamais (erreur de chargement…), on passe au site
  useEffect(() => {
    const timer = setTimeout(() => finish(), 15000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // L'animation démarre tout de suite, sans clic : la vidéo est muette, donc les
  // navigateurs la laissent toujours se lancer. Le son est tenté à part ; s'il est
  // bloqué (le navigateur exige une interaction), il démarre au premier clic ou touche.
  useEffect(() => {
    const video = videoRef.current;
    const audio = audioRef.current;

    if (video) {
      video.addEventListener("ended", finish, { once: true });
      // Un play() interrompu (ex. double montage en développement) n'est pas une erreur :
      // la vraie panne est gérée par onError et par la minuterie de sécurité.
      video.play().catch(() => {});
    }

    const startSound = () => {
      if (!audio || doneRef.current) return;
      audio.currentTime = video ? video.currentTime : 0;
      audio.play().catch(() => {});
    };
    if (audio) {
      audio.play().catch(() => {
        window.addEventListener("pointerdown", startSound, { once: true });
        window.addEventListener("keydown", startSound, { once: true });
      });
    }

    return () => {
      window.removeEventListener("pointerdown", startSound);
      window.removeEventListener("keydown", startSound);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{ background: BG, opacity: fading ? 0 : 1, transition: "opacity 0.8s ease" }}
    >
      <audio ref={audioRef} src={logoSound} preload="auto" />
      <video
        ref={videoRef}
        src={logoVideo}
        autoPlay
        playsInline
        muted
        preload="auto"
        onError={finish}
        style={{ maxWidth: "900px", width: "90%", maxHeight: "90vh", objectFit: "contain", background: BG }}
      />

      <button
        type="button"
        onClick={finish}
        className="absolute bottom-6 right-6 px-4 py-2 rounded-full text-sm font-semibold text-sauge-dark bg-white/60 hover:bg-white transition-colors"
      >
        {t("Passer l'intro")}
      </button>
    </div>
  );
};

export default SplashScreen;
